import { useEffect, useState } from "react";
import api from "@/lib/api";
import { StockBadge } from "@/components/StockBadge";
import { RefreshCw } from "lucide-react";

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("en-IE", { timeZone: "Europe/Dublin" }) : "—");

export default function Inventory() {
  const [rows, setRows] = useState([]);
  const [live, setLive] = useState(true);

  const load = () => api.get("/admin/inventory").then(({ data }) => setRows(data));
  useEffect(() => { load(); if (!live) return; const t = setInterval(load, 5000); return () => clearInterval(t); }, [live]);

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-serif-display text-3xl font-bold text-slate-50">Real-Time Inventory Monitor</h1>
          <p className="mt-1 text-sm text-[#94A3B8]">Available to Order = Sage Stock − Reserved − Safety Stock</p>
        </div>
        <button data-testid="inventory-live-toggle" onClick={() => setLive((v) => !v)}
          className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold ${live ? "border-emerald-500/40 text-emerald-400" : "border-[#2A2E39] text-slate-300"}`}>
          <RefreshCw className={`h-4 w-4 ${live ? "animate-spin" : ""}`} /> {live ? "Live" : "Paused"}
        </button>
      </div>

      <div className="mt-8 overflow-x-auto rounded-2xl border border-[#2A2E39]">
        <table className="w-full text-left text-sm">
          <thead className="bg-[#121418] text-xs uppercase tracking-wider text-[#64748B]">
            <tr>
              {["SKU", "Product", "Brand", "Sage Stock", "Reserved", "Safety", "Available", "Status", "Last Sage Update", "Sync"].map((h) => (
                <th key={h} className="whitespace-nowrap px-4 py-3 font-semibold">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-[#2A2E39]">
            {rows.map((r) => (
              <tr key={r.sku} data-testid={`inventory-row-${r.sku}`} className="mc-table-row">
                <td className="whitespace-nowrap px-4 py-3 font-mono-data text-[#D4AF37]">{r.sku}</td>
                <td className="px-4 py-3 text-slate-100">{r.product}</td>
                <td className="px-4 py-3 text-[#94A3B8]">{r.brand}</td>
                <td className="px-4 py-3 font-mono-data text-slate-100">{r.sage_stock}</td>
                <td className="px-4 py-3 font-mono-data text-amber-400">{r.reserved}</td>
                <td className="px-4 py-3 font-mono-data text-[#94A3B8]">{r.safety_stock}</td>
                <td className="px-4 py-3 font-mono-data text-lg font-bold text-slate-50">{r.available}</td>
                <td className="px-4 py-3"><StockBadge status={r.stock_status} testId={`inventory-stock-${r.sku}`} /></td>
                <td className="whitespace-nowrap px-4 py-3 font-mono-data text-xs text-[#94A3B8]">{fmtTime(r.last_sage_update)}</td>
                <td className="px-4 py-3">
                  <span className={`rounded-full border px-2 py-0.5 text-[10px] font-bold ${r.sync_status === "LIVE" ? "border-emerald-500/40 text-emerald-400" : "border-rose-500/40 text-rose-400"}`}>{r.sync_status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
